<template>
  <input
    :input="value"
    @input="emit('input', $event.target.value)"
    class="filter-input"
    :placeholder="i18n.t('exchange-form.drop-down.search')"
  >
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { i18n } from '@/i18n';

const props = defineProps<{
  value: string
}>();

const emit = defineEmits<{
  (event: 'input', value: string): void,
}>();

const value = computed({
  get: () => props.value,
  set: (value: string) => emit('input', value),
});
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.filter-input {
  background: #FFFFFF;
  border: 1px solid $black-10;
  border-radius: 6px;
  padding: 16px 14px;
  width: 100%;
  height: rem(29);

  @media screen and (min-width: $screen-md-min) {
    height: rem(48);
  }
}
</style>
